var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAexHandsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 431.49 420.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M264.47,416h-75C144.58,416,110.3,402.64,81.61,374,52,344.38,27.84,293.52,24.33,286l-18.8-18.1a17.89,17.89,0,0,1-1.27-24.52C11.45,235,24.78,225,47.47,225c16.43,0,36.7,13.52,60.25,40.19a372.56,372.56,0,0,1,29.95,39.09,5,5,0,0,1-8.39,5.44,368.21,368.21,0,0,0-29.13-38C78.92,247.7,60.7,235,47.47,235c-18.89,0-29.8,8.07-35.62,14.85a7.88,7.88,0,0,0,.62,10.8L31.94,279.4A5,5,0,0,1,33,280.93c.26.56,25.63,55.92,55.66,85.95C115.38,393.57,147.4,406,189.47,406h75a5,5,0,0,1,0,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.47,315a5,5,0,0,1-4.94-4.25c-3.18-21.1-11.45-36.29-24.57-45.15-20.34-13.72-46.06-7.8-46.32-7.74a5,5,0,0,1-2.34-9.72c1.21-.29,30.11-7,54.17,9.12,15.59,10.47,25.33,28,28.95,52a5,5,0,0,1-4.2,5.69A4.74,4.74,0,0,1,237.47,315Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M118.47,291a5,5,0,0,1-5-5V67c0-15,11-29.83,25.63-34.49,6.71-2.14,23.9-4.91,38.45,15.6a5,5,0,0,1,.92,2.89V188a5,5,0,0,1-10,0V52.64C161,42.77,151.65,39,142.14,42c-10.47,3.33-18.67,14.3-18.67,25V286A5,5,0,0,1,118.47,291Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.47,194a5,5,0,0,1-5-5V37.1c-.07-1.76-1.6-27.1-25-27.1-24.61,0-25,34.54-25,36a5,5,0,0,1-5,5h0a5,5,0,0,1-5-5c0-15.91,7.32-46,35-46,26.78,0,34.6,24.1,35,36.84V189A5,5,0,0,1,232.47,194Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M289.47,198a5,5,0,0,1-5-5V75c0-.09,0-.19,0-.29s.8-16.65-7.11-25c-3-3.17-6.9-4.71-11.9-4.71-11.55,0-18.18,2.54-21.72,4.68S239.07,54,239,54.06l.06-.14-9.23-3.84C230.5,48.53,237,35,265.47,35c7.8,0,14.26,2.65,19.19,7.86C295.14,54,294.57,73,294.47,75.12V193A5,5,0,0,1,289.47,198Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.47,210a5,5,0,0,1-5-5V116a3.71,3.71,0,0,1,0-.47,54.31,54.31,0,0,0-1.2-15.24c-2.2-9.29-6.89-14.81-13.93-16.41C302.69,79.63,294,88,293.59,88.4a5,5,0,0,1-7.18-7c.51-.53,12.7-12.87,37.17-7.31,25.13,5.71,23.18,38.59,22.89,42.09V205A5,5,0,0,1,341.47,210Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343,421a89,89,0,0,1-62.56-26.07,87.37,87.37,0,0,1-25.74-62.19c0-48.63,39.73-88.29,88.53-88.42h.23A88.34,88.34,0,0,1,343.71,421Zm-.18-164a75.77,75.77,0,0,0-.06,151.53H343a75.94,75.94,0,0,0,75.75-75.6A75.73,75.73,0,0,0,342.86,257l-.08-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.82,378.4a5,5,0,0,1-3.53-1.46l-81.5-81.5a5,5,0,0,1,7.07-7.07l81.5,81.5a5,5,0,0,1-3.54,8.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.32,378.4a5,5,0,0,1-3.53-8.53l81.5-81.5a5,5,0,1,1,7.07,7.07l-81.5,81.5A5,5,0,0,1,302.32,378.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAexHandsUp);
export default __webpack_public_path__ + "static/media/aex_hands_up.228789e246f95429118cc01a3cad6ebe.svg";
export { ForwardRef as ReactComponent };